import ChartBase from "./ChartBase";
export class ProgressChart extends ChartBase {
    constructor() {
        super();
        this.progressItems = [];
        this._progressItemTemplate = () => {
            const node = document.createElement("div");
            node.classList.add("col-sm-auto");
            node.setAttribute("data-progress-item", "");
            node.innerHTML = `
                            <div class="btn-icon-end mb-1">
                                <span data-progress-status>Positive Change</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="448" height="512" viewBox="0 0 448 512" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-xs">
                                    <path d="M272 480h-96c-13.3 0-24-10.7-24-24V256H48.2c-21.4 0-32.1-25.8-17-41L207 39c9.4-9.4 24.6-9.4 34 0l175.8 176c15.1 15.1 4.4 41-17 41H296v200c0 13.3-10.7 24-24 24z"></path>
                                </svg>
                            </div>
                            <div class="d-flex align-items-center">
                                <div class="dashboard-charts-progress">
                                    <div class="dashboard-charts-progress-fill" data-progress-fill>
                                    </div>
                                </div>
                                <div class="ml-2" data-progress-percentage>
                                    100%
                                </div>
                            </div>
                                `;
            this.progressItems.push(node);
            return node;
        };
        this._init = () => {
            // chart type
            this.chartType = "ProgressChartFull";
            // always call this
            this._getElements();
            // get survey name element
            // this.surveyNameElement = this.wrapper.querySelector("[data-surveyname]");
        };
        this.updateData = (props) => {
            // get correct props
            var correctProps = props;
            // test combined props
            if (props.chartData) {
                correctProps = props.chartData;
            }
            //set metric and question
            this._setBaseInfo(props);
            // get data and labels
            const { data, survey, questionNo } = correctProps;
            //if (survey && questionNo) {
            //    this.surveyName = "Survey" + survey + " >> " + questionNo;
            //}
            // get length
            const length = this.length > 0 ? this.length : data.length;
            data.forEach((dataitem, index) => {
                // render 
                if (index < length) {
                    // add new UI element if not exist
                    if (this.progressItems.length <= index) {
                        // add item UI
                        const progressContainer = this.wrapper.querySelector(".dashboard-charts-progress-wrapper > .row");
                        progressContainer.append(this._progressItemTemplate());
                    }
                    this._renderData(this.progressItems[index], dataitem);
                }
            });
            // remove loading
            this.loading = false;
        };
        this._renderData = (element, data) => {
            let statusText = "";
            let statusClass = "";
            if (data.status == "Positive") {
                statusText = "Positive Change";
                statusClass = "positive";
            }
            if (data.status == "Negative") {
                statusText = "Negative Change";
                statusClass = "negative";
            }
            if (data.status == "Neutral") {
                statusText = "No Change";
                statusClass = "neutral";
            }
            // set status
            element.classList.remove("positive");
            element.classList.remove("negative");
            element.classList.remove("neutral");
            element.classList.add(statusClass);
            element.querySelector("[data-progress-status]").textContent = statusText;
            element.querySelector("[data-progress-fill]").style.width = data.percentage + "%";
            element.querySelector("[data-progress-percentage]").textContent = data.percentage + "%";
        };
    }
    get length() {
        return parseInt(this.getAttribute("length") || "-1");
    }
    connectedCallback() {
        // html template
        this.innerHTML = `
            <div class="${this.class} dashboard-charts-item" data-wrapper>
                <div class="d-flex align-items-center mb-3">
                    <h6 class="text-uppercase font-weight-bold mb-0" data-metric></h6>
                    ${!!this.chartName ? `<div class="dashboard-charts-name">${this.chartName}</div>` : ''}
                </div>
                <p class="text-muted-light font-italic dashboard-charts-item-question mb-2" data-question></p>
                <div class="dashboard-charts-progress-wrapper">
                    <div class="row">
                        <div class="col-sm mr-auto">
                            <div class="font-weight-bold d-flex align-items-center mb-3" data-surveyname>
                                Survey 01
                                        <svg xmlns="http://www.w3.org/2000/svg" width="448" height="512" viewBox="0 0 448 512" fill="currentColor" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="icon icon-xs mx-1">
                                            <path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"/>
                                        </svg>
                                3
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        this._init();
    }
}
window.customElements.define("sva-progress-chart", ProgressChart);
